<template>
  <v-container class="fill-height with-fancy-bg">
    <v-row
      align="center"
      class="fill-height"
      justify="center">
      <v-col>
        <v-card
          class="mx-auto"
          max-width="688px">
          <div class="right-language-switcher">
            <LanguageSwitcher />
          </div>
          <v-card-title class="text-center mt-10 auth-forms-top-title">
            <span class="text-primary">{{
              $t("views.activation.FirstTitle")
            }}</span>
            <br />
            {{ $t("views.activation.SecondTitle") }}
          </v-card-title>
          <v-card-subtitle
            v-if="errorMessage"
            class="auth-forms-sub-title text-center text-red">
            {{ $t("actions.error-message") }}
            {{ $t("actions.error-responses." + errorMessage) }}
          </v-card-subtitle>

          <v-card-text>
            <v-row class="mt-6">
              <v-col>
                <router-link
                  v-if="errorMessage"
                  class="mr-4 auth-forms-sub-title"
                  :to="{ name: 'login' }">
                  {{ $t("views.register.Login") }}
                </router-link>
                <v-progress-linear
                  v-else
                  color="primary"
                  indeterminate />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";

import { useAuthStore } from "@/stores/authStore";

const { t } = useTranslation();
const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const errorMessage = ref(null);

onMounted(() => {
  if (route.query.token && route.query.token.length > 0) {
    authStore
      .activate(route.query.token)
      .then(() => {
        router.push({ name: "login" });
      })
      .catch((error) => {
        errorMessage.value = error.response.data;
        console.error(errorMessage);
      });
  } else {
    errorMessage.value = t("views.activation.NoToken");
  }
});
</script>
